"use strict";

const idlUtils = require("../generated/utils.js");

exports.implementation = class FileListImpl extends Array {
  constructor() {
    super(0);
  }
  item(index) {
    return this[index] || null;
  }
  get [idlUtils.supportedPropertyIndices]() {
    return this.keys();
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/file-api/FileList-impl.js
// module id = zi1y
// module chunks = 0